<template>
    <div id="ficheFournisseur">
        <b-row class="backInfoMain2">

            <s-menuSave 
                :msg="sendMsg" 
                newBtn 
                :btnSaveDisabled="checkAllField" 
                @new="menuNew()" 
                saveBtn 
                @save="menuSave()" 
                :deleteBtn="checkDeleteBtn"
                @delete="menuDelete(activeObj.id)"
                :msgText="sendMsg2"
                :msgType="getTheme.primary">
            </s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <s-itemList 
                    v-if="supplierList"
                    :content="supplierList" 
                    :returnValue.sync="activeObj"
                    activeField="isActive" 
                    :selectedItems="activeObj"
                    multiColonne
                    :fields="fields"
                    @getRowdDetail="getRowdDetail"
                    >
                </s-itemList>
            </b-col>
            <!--Fin section de gauche-->
            
<!--****************************************************************************************************************************************************************-->
            
            <!--Section du centre-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">

                <!--INFORMATIONS DU FOURNISSEUR-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('s_Informations')}}</div>
                            <div class="itemContain">
                                <s-input id = "name" name="name" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('s_Fournisseur')" v-capitalize v-model="activeObj.supplier" :state="isValid(activeObj.supplier)"></s-input>
                                <s-input id = "website" name="website" type="text" maxlength="255" class="MargeTop15" :placeholder="$t('s_Website')" v-model="activeObj.webSite" ></s-input>

                                <!--ADDRESS-->
                                <tabsAddress :parentId="activeObj.id" :addressList.sync="activeObj.addressList" @updateAddress="updateAddress" @saveNewAddress="saveNewAddress" @removeAdress="removeAdress" />

                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--CONTACT-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('s_Contact')}}</div>
                            <div class="itemContain txtMain">

                                <tabsContact type="supplierContacts" :contactList.sync="activeObj.contactList" @saveNewContact="saveNewContact" @removeContact="removeContact" @updateContact="updateContact" @insertContact="insertContact"/>

                            </div>
                        </div>
                    </b-col>
                </b-row>

                

            </b-col>
            <!--FIN - Section de droite-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">
                
                <!--Options-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('s_Options')}}</div>
                            <div class="itemContain txtMain">
                                   
                                <!--Fournisseur-->
                                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="activeObj.isType">{{$t('s_EstTypeFournisseur')}}</b-form-checkbox>
                                <!--Réparateur-->
                                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="activeObj.isRepair">{{$t('s_EstTypeReparateur')}}</b-form-checkbox>
                                
                                <!--TERME-->
                                <comboSelector 
                                :name="$t('s_Terme')" 
                                :content="termList" 
                                :title="$t('s_Terme')" 
                                showField="term"
                                returnField="id"
                                :returnValue.sync="activeObj.term"
                                :selectedItems="activeObj.term"></comboSelector>
                                
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--NOTE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('s_Note')}}</div>
                            <div class="itemContain">
                                <b-form-textarea
                                    id="Note"
                                    v-model="activeObj.note"
                                    :placeholder="$t('cc_Note')"
                                    rows="4"
                                    max-rows="4"
                                    maxlength="255"
                                    style="margin-top: 5px">
                                </b-form-textarea>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--Courriels d'envoi-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('s_Emails')}}</div>
                            <div class="itemContain txtMain">
                                   
                                <!--Courriel principal-->
                                <s-input id = "email1" name="email1" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('s_EmailPrincipal')" v-model="activeObj.email1" ></s-input>
                                <!--Courriel personnel -->
                                <s-input id = "email2" name="email2" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('s_EmailPersonnel')" v-model="activeObj.email2" ></s-input>
                                <!--Courriel commande -->
                                <s-input id = "email3" name="email3" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('s_EmailCommande')" v-model="activeObj.email3" ></s-input>
                                <!--Courriel réparation -->
                                <s-input id = "email4" name="email4" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('s_EmailReparation')" v-model="activeObj.email4" ></s-input>
                                <!--Courriel autre -->
                                <s-input id = "email5" name="email5" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('s_EmailDivers')" v-model="activeObj.email5" ></s-input>
                                
                                
                            </div>
                        </div>
                    </b-col>
                </b-row>

            </b-col>
        </b-row>
        
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'

import tabsAddress from '@/components/communs/s-tabsAddress/s-tabsAddress.vue'
import tabsContact from '@/components/communs/s-tabsContact/s-tabsContact.vue'
import comboSelector from '@/components/communs/s-comboSelector/s-comboSelector.vue'
import {dataService} from '@/services'
import SocketioService from '@/plugins/socket/socketio.service.js'
import store from '@/store'
var _ = require('lodash');

export default{
    name: "ficheFournisseur",
    mixins:[mapGetter],
    components: {
        tabsAddress,
        tabsContact,
        comboSelector,
    },
    data() {
        return{
            termList : [],
            supplierList : [],
            InitialState: null, //Format initial de : activeObj
            activeObj:{}, //Créé à l'ouverture à partir du modèle vide dans l'api
            originalObj : {},
            fields:[
                {
                    colName: "id",
                    label: "id",
                    show: false,
                },
                {
                    colName: "supplier",
                    label: this.$i18n.t('s_Fournisseur') ,
                    show: true,
                },
            ], 
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            sendMsg2: 'vide', //message a utiliser pour le menu en haut de la page New/Save/Delete
        
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        /**
         * Reinitialise tous les champs de la fiche fournisseur
         */
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.originalObj = this.$CObj(this.activeObj)
        },
        /**
         * Crée un nouveau fiche fournisseur vide
         */
        menuNew(){
            this.resetAll()
        },
        /**
         * Charge les données des fournisseurs 
         */
        loadApi() {    
            
            this.sendMsg = '4'
            dataService.getSuppliers()
            .then(response => {
                if(response.statusText == 'OK')
                {
                    this.sendMsg = ''
                    let data = response.data;
                    return data;
                }
            })
            .then(response => {
                this.supplierList = this.$CObj(response.data.supplierList)
                this.termList = this.$CObj(response.data.termList)
                this.InitialState = this.$CObj(response.addons.classes.supplierList[0])
                this.activeObj = this.$CObj(this.InitialState)
                this.originalObj = this.$CObj(this.InitialState)
            })
            .catch(error =>{
                this.sendMsg = ''
                console.log(error);
            })


            /*    
            if(typeof this.payload?.data?.supplierList == 'undefined') {
                //Charger les fournisseurs depuis le serveur si ils ne sont pas présent locallement
                this.sendMsg = '4'
                dataService.getSuppliers()
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg = ''
                        let data = response.data;
                        return data;
                    }
                })
                .then(response => {
                    console.log(response)
                    this.supplierList = this.$CObj(response.data.supplierList)
                    this.termList = this.$CObj(response.data.termList)
                    this.InitialState = this.$CObj(response.addons.classes.supplierList[0])
                    this.activeObj = this.$CObj(this.InitialState)
                    this.originalObj = this.$CObj(this.InitialState)
                })
                .catch(error =>{
                    this.sendMsg = ''
                    console.log(error);
                })

            } else {
                //Les données chargées depuis le localStorage
                this.termList = this.$CObj(this.payload.data.termList)
                this.InitialState = this.$CObj(this.payload.addons.classes.supplierList[0])
                this.activeObj = this.$CObj(this.InitialState)
                this.originalObj = this.$CObj(this.InitialState)
            }
            */
        },
        /**
         * Sauvegarde la fiche fournisseur
         */
        menuSave(){
            let t = this.activeObj
            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                this.sendMsg = '-'
                dataService.addSupplier(t)
                .then((response) => {
                    console.log(response)
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg2 ='add Supplier OK';
                        this.sendMsg = ''
                        const newSupplier = response.data.data
                        SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'suppliers', payload: newSupplier});
                        this.supplierList.unshift(newSupplier)
                        this.resetAll()
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if(error.data.data == "") {
                        this.sendMsg2 = error.data.addons.errorFr;
                    }
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                this.sendMsg = '-'
                dataService.updateSupplier(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            this.sendMsg2 ='update OK';
                            const updatedSupplier = response.data.data
                            SocketioService.getSocket().emit('afterUpdate', {action: 'afterUpdate', storeName:'suppliers', payload: updatedSupplier});
                            this.supplierList = this.supplierList.map(supplier => {
                                if(supplier.id == updatedSupplier.id)  Object.assign(supplier, updatedSupplier) ;
                                return supplier;
                            });
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = ''
                    console.log(error);
                    alert('update KO');
                });
            }
            setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        /**
         * Désactive la fiche fournisseur
         * @param {int} id - id du fournisseur
         */
        menuDelete(id){
            if (id == '0') return;
            this.sendMsg = '-'
            dataService.deleteSupplier(id)
            .then((response) => {
                if(response.statusText == 'OK')
                {   
                    this.sendMsg = ''
                    SocketioService.getSocket().emit('afterDelete', {action: 'afterDelete', storeName:'suppliers', payload: {id:id, isActive:false}});
                    this.supplierList = this.supplierList.map(supplier => {
                        if(supplier.id == id)  supplier.isActive = !supplier.isActive;
                        return supplier;
                    });
                    this.resetAll()
                }
            })
            .catch((error) => {
                this.sendMsg = '';
                console.log(error);
            });
        },
        /**
         * Retourne les détails du fournissueur 
         * @param {int} id - id du fournisseur
         */
        getRowdDetail(id)
        {
            /*
            this.sendMsg = '-'
            let supplier = this.supplierList.find(supplier => typeof supplier !== 'undefined' && supplier.id == id);
            
            if(supplier)
            {
                this.activeObj = this.$CObj(supplier)
                this.sendMsg2 ='getContact OK';
                this.originalObj = this.$CObj(this.activeObj)
                this.InitialState = this.$CObj(this.payload.addons.classes.supplierList[0])
                bus.$emit('initContacts', {id:this.activeObj.id, contactList : this.activeObj.contactList});
            }
            this.sendMsg = ''
            */

            
            this.sendMsg = '-'
            dataService.getSupplier(id)
            .then((response) => {
                if(response.statusText == 'OK') {
                    let data = response.data.data;
                    this.activeObj = data[0]
                    this.sendMsg2 ='getSupplier OK';
                    this.originalObj = this.$CObj(this.activeObj)
                    this.InitialState = this.$CObj(response.data.addons.classes[0])
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = ''
                console.log(error);
                if(error.data.data == "") {
                    this.sendMsg2 = error.data.addons.errorFr;
                }
            });
        },

        /**
         * Enregistre les modifications de l'adresse
         * @param {Object} params -  adresse du fournisseur
         */
        updateAddress(params) {
            let address = params.address;
            if(this.activeObj.id > 0) {
                console.log('===> updateSupplierAddress');
                console.log(this.activeObj.id);
                console.log(address);
                dataService.updateSupplierAddress(this.activeObj.id,address)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        let addressList = response.data.data.addressList
                        this.activeObj.addressList = this.$CObj(addressList);
                        this.sendMsg2 ='Update addresse OK';
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            } else { //Modifier une addresse en mode ajout de client
                if(this.activeObj.addressList[0].id != 0 && this.activeObj.addressList[0].label != '') {
                    this.activeObj.addressList.unshift(this.$CObj(this.InitialState.addressList[0]))
                }
            }
        },
        /**
         * Enregistre une nouvelle adresse
         * @param {Object} params -  adresse du fournisseur
         */
        saveNewAddress(params){
            let newAddress = params.newAddress;
            if(this.activeObj.id > 0) {
                dataService.addSupplierAddress(this.activeObj.id,newAddress)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        let addressList = response.data.data.addressList
                        this.activeObj.addressList = this.$CObj(addressList);
                        this.sendMsg2 ='Save addresse OK';
                    }
                })
                .catch(error => {
                    this.sendMsg2 = error;
                });
            } else { //Ajouter une addresse en mode ajout de client
                this.activeObj.addressList.unshift(this.$CObj(this.InitialState.addressList[0]));
            }
        },
        /**
         * Désactive l'adresse
         * @param {Object} params - Id de l'adresse à désactiver
         */
        removeAdress(params){
            let addressid = params.addressId;
            dataService.deleteSupplierAddress(this.activeObj.id, addressid)
            .then((response) => {
                if(response.statusText == 'OK')
                {
                    let addressList = response.data.data.addressList
                    this.activeObj.addressList = this.$CObj(addressList);
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        /**
         * Désactive un contact
         * @param {Object} params - Id du contact à désactiver
         */
        removeContact(params){
            let contactId = params.contactId;
            if(this.activeObj.id == 0) { 
                let contactList = this.$CObj(this.activeObj.contactList)
                _.remove(contactList, {contactId:contactId })

                this.activeObj.contactList = contactList
            }else {
                dataService.detachContactFromSupplier(this.activeObj.id,contactId)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        let contactList = response.data.data.contactList
                        this.activeObj.contactList = this.$CObj(contactList);

                        dataService.getSuppliers()
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            }
        },
        /**
         * Enregistre un nouveau contact
         * @param {Object} params - nouveau contact
         */
        saveNewContact(params){
            let newContact = params.newContact;
            if(this.activeObj.id > 0) {
                dataService.addSupplierContact(newContact)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        const savedContact = response.data.data
                        return savedContact
                    }
                })
                .then((contact) => {
                    dataService.attachContactToSupplier(this.activeObj.id, {contactId : contact.id})
                        .then((response) => {
                            if(response.statusText == 'OK')
                            {
                                let contactList = response.data.data.contactList
                                this.activeObj.contactList = this.$CObj(contactList);
                                this.sendMsg2 ='Save new Contact OK';

                                dataService.getSuppliers()
                            }
                        })
                        .catch(error => {
                            this.sendMsg2 = error;
                        });
                })
                .catch(error => {
                    this.sendMsg2 = error;
                });
            }
        },
        /**
         * Enregistre les modificatios du contact
         * @param {Object} params - un contact
         */
        updateContact(params) {
            let contact = params.contact;
            if(this.activeObj.id > 0) {
                dataService.updateContactSupplier(contact)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        dataService.getSupplierContacts(this.activeObj.id)
                        .then((response) => {
                            if(response.statusText == 'OK')
                            {
                                let contactList = response.data.data.contactList
                                this.activeObj.contactList = this.$CObj(contactList);
                                this.sendMsg2 ='Update supplier contact OK';

                                dataService.getSuppliers()
                            }
                        })
                        .catch(error => {
                            this.sendMsg2 = error;
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            }
        },
        /**
         * Insére un contact existant dans la fiche fournisseur
         * @param {Object} params - Un contact existant
         */
        insertContact(params) {
            let contact = params.contact;
            if(this.activeObj.id == 0) { 
                let newContact = {contactId:contact.id }
                let contactList = this.$CObj(this.activeObj.contactList)
                
                //Ajouter l'objet du nouveau contact tout en s'assurant qu'il n y aura pas de doublons
                if (_.isEmpty(_.remove(contactList, newContact))) { 
                    contactList.push(newContact);
                } else { contactList.push(newContact); }

                this.activeObj.contactList = contactList
            }
            else {
                dataService.attachContactToSupplier(this.activeObj.id, {contactId : contact.id})
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        let contactList = response.data.data.contactList
                        this.activeObj.contactList = this.$CObj(contactList);
                        this.sendMsg2 ='Insert new Contact OK';

                        dataService.getSuppliers()
                    }
                })
                .catch(error => {
                    this.sendMsg2 = error;
                });
            }
        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        /**
         * Vérifie s'il ya des modifications
         */
        checkAllField() {
            if(this.activeObj.addressList && this.activeObj.addressList.length == 1 && this.activeObj.addressList[0].id == 0) return true
            return JSON.stringify(this.originalObj) === JSON.stringify(this.activeObj)
        },
        /**
         * Vérifie si on autorise la désactivation du client
         */
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
         payload : () => store.getters.getSuppliersOnClient,
        /**
         * Retourne la liste des contacts du payload
         */
         //supplierList() {return this.payload?.data.supplierList},
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() 
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>